
  import Events from '@/events/Events';
  import JobBoxAlert from '@/components/JobBoxAlert';
  import JobBoxWithTypesense from '@/mixins/JobBoxWithTypesense';

  export default {
    name: 'JobBoxNewJobs',
    components: {
      JobBoxAlert,
    },
    mixins: [JobBoxWithTypesense],
    props: {
      numJobPostings: {
        type: Number,
        required: false,
        default: 5,
      },
      sectionFilterParams: {
        type: String,
        required: false,
        default: '',
      },
      icons: {
        type: Boolean,
        required: false,
        default: true,
      },
      jobBoxType: {
        type: String,
        required: false,
        default: 'Compact',
      },
      showJobAlertBox: {
        type: Boolean,
        required: false,
        default: true,
      },
    },
    data() {
      return {
        loading: true,
        jobPostings: [],
        jobAlertSearchRequestUrl: '',
      };
    },
    fetch() {
      this.jobAlertSearchRequestUrl =
        this.sectionFilterParams +
        '&order[order_number]=desc&itemsPerPage=16&page=1';
      this.jobAlertSearchRequestUrl = this.jobAlertSearchRequestUrl.replace(
        /&pagination=false/g,
        ''
      );
      if (!this.jobAlertSearchRequestUrl.includes('isPublished')) {
        this.jobAlertSearchRequestUrl += '&isPublished=1';
      }
    },
    mounted() {
      this.getNewJobPostings().catch((e) => {
        this.jobPostings = [];
        this.loading = false;

        throw e;
      });
    },
    created() {
      this.filterConfig.sectionFilterParams =
        this.sectionFilterParams === ''
          ? new URLSearchParams()
          : new URLSearchParams(this.sectionFilterParams);
      this.filterConfig.numJobPostings = this.numJobPostings * 5;
      this.filterConfig.shuffleAndSlice = this.numJobPostings;
    },
    methods: {
      async getNewJobPostings() {
        // Jobs mit der letzten 24 Stunden
        this.filterConfig.additionalFilterParams.set('created', '86400');

        await this.fetchJobPostings();

        // Weiteres Auffüllen der Jobs mit Jobs der letzten 7 Tage
        if (this.mergedJobPostings.length < this.numJobPostings) {
          // Jobs der letzten 7 Tage, keine SpecialOffers
          this.filterConfig.additionalFilterParams.set('created', '604800');

          await this.fetchJobPostings();
        }

        this.jobPostings = this.mergedJobPostings;

        const items = this.jobPostings.map((item, key) => ({
          id: item.id,
          position: key + 1,
        }));

        this.$emitWithClientData(Events.JobBoxViewed, {
          boxType: 'NewJobs',
          items,
        });
      },
    },
  };
